export default __webpack_public_path__ + "static/media/ENGG_150.a4ca5950.png";